import React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import {Constants} from '../../constants';
import {colors} from '../../styles';
import {InputProps} from './Input';

interface InputContextProps {
  onFocusChange: (focused: boolean) => void;
}

export const InputContext = React.createContext<InputContextProps | undefined>(
  undefined,
);

export interface InputContainerProps extends Omit<InputProps, 'children'> {
  invalid?: boolean;
  style?: ViewStyle;
  // Need unkown so ValidatedField can infer the children props automatically
  children?: unknown;
}

const isMedium = Constants.DIMENSIONS.HEIGHT < Constants.SCREEN_HEIGHT.PX_785;

export const InputContainer: React.FC<InputContainerProps> = ({
  invalid,
  children,
  style,
  ...props
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const onFocusChange = (focused: boolean) => setIsFocused(focused);

  return (
    <InputContext.Provider value={{onFocusChange}}>
      <View
        style={[
          styles.container,
          {paddingVertical: isMedium ? 8 : 14},
          style,
          isFocused && styles.focused,
          invalid && styles.invalid,
        ]}>
        {typeof children === 'function' ? children(props) : children}
      </View>
    </InputContext.Provider>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 24,
    borderWidth: 1,
    borderRadius: 50,
    backgroundColor: colors.gray19,
    borderColor: colors.gray19,
  },
  focused: {
    borderColor: colors.lightMediumGray,
  },
  invalid: {
    borderColor: colors.red,
  },
});
